import React, { useState, useEffect } from 'react';
import logo from '../assets/Images/Clanbridge-logo.png2.png';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const Paymentpage = () => {
  const [searchParams] = useSearchParams();
  const [longUrl, setLongUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token = searchParams.get('token');

  useEffect(() => {
    const fetchLongUrl = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}PaymentGatewayLog/InstamojoLink`,
          {
            Trasid: token,
            Flag: '',
            TrjDocId: 0,
          },
          {
            headers: {
              Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`,
            },
          }
        );
        if (response.data?.Status === 1) {
          setError(`⚠️ ${response.data?.Message || 'Unknown error occurred.'}`);
          return;
        }
        const dataArray = response.data?.Data;
        if (Array.isArray(dataArray) && dataArray.length > 0 && dataArray[0].longUrl) {
          setLongUrl(dataArray[0].longUrl);
        }
         else {
          setError('⚠️ Payment link has expired.');
        }
      } catch (err) {
        console.error(err);
        setError('❌ Error fetching payment link. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchLongUrl();
    } else {
      setError('Invalid payment token.');
      setLoading(false);
    }
  }, [token]);

  const handleProceed = () => {
    if (longUrl) {
      window.open(longUrl, '_blank');
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img src={logo} alt="Clanbridge Logo" style={styles.logo} />

        {loading && <p style={styles.message}>⏳ Loading payment details...</p>}

        {error && <p style={styles.error}>{error}</p>}

        {!loading && !error && (
          <>
            <h2 style={styles.title}>You're Almost There!</h2>
            <p style={styles.subtitle}>Click the button below to proceed with your payment.</p>
            <button style={styles.button} onClick={handleProceed}>
              Proceed to Pay
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '91vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f2f4f8',
    padding: '20px',
  },
  card: {
    width: '100%',
    maxWidth: '450px',
    backgroundColor: '#fff',
    padding: '40px 30px',
    borderRadius: '10px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  logo: {
    width: '180px',
    marginBottom: '5px',
  },
  title: {
    fontSize: '24px',
    color: '#1b1b1b',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#555',
    marginBottom: '30px',
  },
  message: {
    fontSize: '16px',
    color: '#555',
  },
  error: {
    color: '#d32f2f',
    fontWeight: 'bold',
    fontSize: '16px',
    marginTop: '10px',
  },
  button: {
    backgroundColor: '#1b29a7',
    color: 'white',
    padding: '14px 30px',
    fontSize: '16px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

styles.button[':hover'] = {
  backgroundColor: '#0f1c80',
};

export default Paymentpage;
